import 'intersection-observer'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { blockInviewHandler } from '../../../drupal/rendering/inview_utils.mod'
import { Link } from '../types.gen'
import { getClassName, link } from '../utils.gen'
import { CMSState } from '../../../publicSite/drupalPage/state'

export type TextBlockProps = {
  index: number
  title?: React.ReactNode
  text: string
  primary_button?: ({ kind: 'button'; on_click: () => Updater<CMSState> } | Link) & {
    title: string
  }
  link?: Link
  link_type: boolean
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type TextBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_wrapper_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function TextBlockWidget(
  props: TextBlockProps,
  options?: { style?: TextBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX((onDone) => (
      <InView
        as="section"
        onChange={(inView) =>
          blockInviewHandler(
            'text',
            inView,
            `io-${options && options.key ? options.key : props.index}`,
            getClassName(options, 'inview_classname', 'inview')
          )
        }
        triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
        threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
        id={`io-${options && options.key ? options.key : props.index}`}
        className={getClassName(options, 'block_classname', 'container')}
        key={options && options.key ? options.key : `block-${props.index}`}
      >
        <div className={getClassName(options, 'inner_classname', 'py-5')}>
          {props.title && (
            <header className={getClassName(options, 'header_classname', '')}>
              <h2 className={getClassName(options, 'title_classname', 'mb-3')}>{props.title}</h2>
            </header>
          )}

          <div className={getClassName(options, 'content_classname', '')}>
            <div
              className={getClassName(options, 'text_classname', '')}
              dangerouslySetInnerHTML={{ __html: props.text }}
            />
          </div>

          {(props.primary_button || (props.link && props.link.title && props.link.url)) && (
            <footer className={getClassName(options, 'footer_classname', '')}>
              {props.primary_button && (
                <div className={getClassName(options, 'clickable_wrapper_classname', 'd-inline-block')}>
                  {props.primary_button.kind === 'button' ? (
                    <button
                      className={
                        props.link_type === false
                          ? getClassName(options, 'clickable_primary_classname', 'btn btn-dark mr-2')
                          : getClassName(options, 'clickable_secondary_classname', 'btn btn-link px-0 mr-2')
                      }
                      onClick={() => props.primary_button.kind === 'button' && onDone(props.primary_button.on_click())}
                    >
                      {props.primary_button.title}
                    </button>
                  ) : (
                    props.primary_button.title &&
                    props.primary_button.url &&
                    link(
                      props.primary_button,
                      {
                        classname:
                          props.link_type === false
                            ? getClassName(options, 'clickable_primary_classname', 'btn btn-dark mr-2')
                            : getClassName(options, 'clickable_secondary_classname', 'btn btn-link px-0 mr-2')
                      },
                      props.primary_button.title
                    )
                  )}
                </div>
              )}
              {props.link && props.link.title && props.link.url && (
                <div className={getClassName(options, 'clickable_wrapper_classname', 'd-inline-block')}>
                  {link(
                    props.link,
                    { classname: getClassName(options, 'clickable_secondary_classname', 'btn btn-link px-0') },
                    props.link.title
                  )}
                </div>
              )}
            </footer>
          )}
        </div>
      </InView>
    ))
}
